import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/global.css';
import './components/SimpleNotification/SimpleNotification.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/trivia_quiz">
        <App />
    </BrowserRouter>
);